import React, { Component } from 'react';

import Crime from './Crime';
import Dtp from './Dtp';

import { CaseMainTitle } from '../../components/newDesign/CaseMainTitle';
import { MainWrapper } from '../../components/newDesign/MainWrapper/MainWrapper';
import { RadioGroup } from '../../components/newDesign/RadioGroup';

const tabs = [
  {
    name: 'Криминогенная обстановка',
  },
  {
    name: 'ДТП',
  },
];

const NAME_COMP = {
  'Криминогенная обстановка': <Crime />,
  'ДТП': <Dtp />,
};

class Safety extends Component {
  constructor(props) {
    super(props);
    this.state = {
      radio: Object.keys(NAME_COMP)[0],
    };
  }

  radioChange = (value) => {
    this.setState({
      radio: value.target.value,
    });
  };

  render() {
    // const { subtabs } = this.props;
    // const newSubtabs = subtabs.filter(it => it.name !== "Карта опасных участков");
    return (
      <MainWrapper>
        <CaseMainTitle>Общественная безопасность</CaseMainTitle>
        <RadioGroup
          onChange={this.radioChange}
          value={this.state.radio}
          list={tabs.map((i) => ({
            key: i.name,
            value: i.name,
          }))}
        />
        {Object.keys(NAME_COMP).map((nav) => {
          if (nav === this.state.radio) return NAME_COMP[nav];
          else return null;
        })}
      </MainWrapper>
    );
  }
}

export default Safety;
